/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hour: NonNullable<unknown> }} Fw_Notify_Digest_AtInputs */

const en_fw_notify_digest_at = /** @type {(inputs: Fw_Notify_Digest_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every day at ${i?.hour}:00 (WIB)`)
};

const id_fw_notify_digest_at = /** @type {(inputs: Fw_Notify_Digest_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Setiap hari pukul ${i?.hour}.00 WIB`)
};

/**
* | output |
* | --- |
* | "Every day at {hour}:00 (WIB)" |
*
* @param {Fw_Notify_Digest_AtInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_digest_at = /** @type {((inputs: Fw_Notify_Digest_AtInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Digest_AtInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_digest_at(inputs)
	return en_fw_notify_digest_at(inputs)
});